import * as React from 'react';
import { BrowserAPIContextProvider } from './BrowserAPI/BrowserAPI.js';
import { EnvironmentContextProvider } from './Environment.js';
import { IconContextProvider } from './Icon.js';
import { MediaQueryContextProvider } from './MediaQuery.js';

var AdsSystemContextProvider = /*#__PURE__*/React.memo(function (_ref) {
  var children = _ref.children,
    _ref$value = _ref.value,
    icons = _ref$value.icons,
    environment = _ref$value.environment,
    browserAPI = _ref$value.browserAPI;
  return /*#__PURE__*/React.createElement(BrowserAPIContextProvider, {
    value: browserAPI
  }, /*#__PURE__*/React.createElement(EnvironmentContextProvider, {
    value: environment
  }, /*#__PURE__*/React.createElement(MediaQueryContextProvider, null, /*#__PURE__*/React.createElement(IconContextProvider, {
    value: icons
  }, children))));
});
AdsSystemContextProvider.displayName = 'AdsSystemContextProvider';

export { AdsSystemContextProvider };
//# sourceMappingURL=AdsSystemContextProvider.js.map
